import { GeometryChangeRetriever } from "./geometryChangeRetriever";
import Logger from "../../../common/util/Logger";
import { ChangeTypes, GeometryChange } from "./types";
import { numberComparator } from "../../../core/comparators/numberComparator";
import { isPointCoordinates } from "../../../core/geo/assertions";
import { Feature, Point } from "geojson";

const logger = new Logger("pointRetriever");

const getCoordinates = (feature: Feature | undefined) => {
    return (feature?.geometry as Point)?.coordinates;
};

export const pointChangeRetriever: GeometryChangeRetriever = {
    retrieveChange(featureBefore, featureNow, featureOptions): GeometryChange[] {
        const oldCoordinates = getCoordinates(featureBefore);
        const newCoordinates = getCoordinates(featureNow);
        if (oldCoordinates === undefined) {
            logger.info(`inserting point with coordinates: ${newCoordinates}`);
            return [
                {
                    type: ChangeTypes.INSERT_POINT,
                    coordinateChange: {
                        coordinates: newCoordinates,
                    },
                },
            ];
        }

        if (
            isPointCoordinates(oldCoordinates) &&
            isPointCoordinates(newCoordinates) &&
            numberComparator(oldCoordinates[0], newCoordinates[0]) &&
            numberComparator(oldCoordinates[1], newCoordinates[1])
        ) {
            logger.info("Point feature NOT MOVED");
            return [{ type: ChangeTypes.NONE }];
        }
        logger.info(`Point feature moved, before: ${oldCoordinates}, now: ${newCoordinates}`);
        return [
            {
                type: ChangeTypes.MOVE_POINT,
                coordinateChange: {
                    coordinates: newCoordinates,
                },
            },
        ];
    },
};
